import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { getLogout, roleid } from '../src/component/Actions/AuthAction';
import Error401Page from '../src/component/Pages/Page404';
import { permission, roles } from '../src/content';

function Protected(props) {




    const Cmp = props.Cmp

    const role = roleid()
    var auth = localStorage.getItem('token')

    console.log(auth)


    if (auth) {
        if (role != null) {
            if (permission[roles[role]][props.param]) {
                //return <div> {auth ? <Cmp />: <Redirect to="/"></Redirect>}</div>
                return <div> {auth ? <Route exact={true} path={props.path} component={props.Cmp} /> : <Redirect to="/"></Redirect>}</div>
            } else {
                return <Error401Page />
            }
        } else {
            getLogout(props);
        }

    } else {

        return <Redirect to="/"></Redirect>
    }


}

export default Protected;